import React, { Component, useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getList, showUpdate, showDelete, sendBoleto, imprimir, showView } from './boletoAction'
import ReactPaginate from 'react-paginate';
import If from '../common/operador/if'


class BoletoList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            tipoPesq: '', valorPesq: '', enableInputPesquisa: true, itensPorPag: 16,
            pageCount: 0
        }
    }

    componentWillMount() {
        this.props.getList('','',this.props.usuario.unidade)
    }

    getTipo(tipo) {
        return tipo ? 'Avulso' : 'Carnê'
    }

    getDataFormatada(data) {
        let ArrDt = data.split(' ')[0].split('-')
        return `${ArrDt[2]}/${ArrDt[1]}/${ArrDt[0]}`
    }

    getRetSimNao(param) {
        return param ? 'S' : 'N'
    }

    getImgBanco(unidade){
        let img = "";
        if (unidade.instituicao_financ == '756'){ // sicoob
            img = './sicoob.png'
        }

        if (unidade.instituicao_financ == '461'){// asaas
            img = './asaas.png'
        }

        if (unidade.instituicao_financ == '001'){// banco do brasil
            img = './bb.png'
        }


        return img;
    }

    getClassImpressoReg(param) {
        return param ? "btn btn-success btn-sm" : "btn btn-danger btn-sm"
    }

    getStatus(item) {
        if (item.dt_exclusao !== null) {
            return `Cancelado: ${this.getDataFormatada(item.dt_exclusao)}`
        } else if (item.dt_credito !== null) {
            return `Pago em: ${this.getDataFormatada(item.dt_credito)}`
        } else return 'Ag. Pagamento'
    }

    isDisableButton(item) {
        return (item.dt_credito !== null || item.dt_exclusao)
    }

    renderRows() {
        if(this.props.list === undefined ) {return};
        const list = this.props.list.rows || []
       
        return list.map(bc => (
            <tr key={bc.id}>
                <td>{bc.id} </td>
                <td>{this.getTipo(bc.boleto_is_avulso)} </td>
                <td>{bc.nome_cliente} </td>
                <td> <img src={this.getImgBanco(bc.unidade)} width={25} height={25}></img></td>
                <td >{bc.cpf_cnpj_cliente} </td>
                <td >{this.getDataFormatada(bc.dt_vencimento)} </td>
                <td >{this.getStatus(bc)} </td>
                <td > <span className={this.getClassImpressoReg(bc.is_registrado)} > {this.getRetSimNao(bc.is_registrado)}</span> </td>
                {/* <td ><span className={this.getClassImpressoReg(bc.is_impresso)}>{this.getRetSimNao(bc.is_impresso)}</span> </td>*/}
                <td>
                    {/* <If test=  {bc.is_registrado || !bc.boleto_is_avulso}>
                                     <button className='btn btn-info btn-sm' disabled={this.isDisableButton(bc)} onClick={() => this.props.showView(bc)}>
                            <i className="fa fa-search-plus"></i>
                        </button>
                    </If>*/}
                   {/*} <If test={!bc.is_registrado && bc.boleto_is_avulso}>*/}
                        <button className='btn btn-warning btn-sm' disabled={this.isDisableButton(bc)} onClick={() => this.props.showUpdate(bc)}>
                            <i className="fa fa-pencil"></i>
                        </button>
                   {/*} </If>*/}
                    <If test={(this.props.usuario.adm)}>  {/*&& bc.boleto_is_avulso)}>*/}
                        <button className='btn btn-danger btn-sm' disabled={this.isDisableButton(bc)} onClick={() => this.props.showDelete(bc)}>
                            <i className="fa fa-trash-o"></i>
                        </button>
                    </If>
                    <If test={bc.is_registrado}>
                        <button className='btn btn-primary btn-sm' disabled={this.isDisableButton(bc)} onClick={() => this.props.imprimir(bc)}>
                            <i className="fa fa-print"></i>
                        </button>
                    </If>
                    <If test={!bc.is_registrado}>
                        <button className='btn btn-success btn-sm' disabled={this.isDisableButton(bc)} onClick={() => this.props.sendBoleto(bc)}>
                            <i className="fa fa-send"></i>
                        </button>
                    </If>
                </td>
            </tr>
        ))
    }

    setItensPorPag = e => {
        this.setState({ ...this.state, itensPorPag: e.target.value })

    }

    setValorTipoPesquisa = e => {
        let tipoPesquisa = e.target.value
        if (tipoPesquisa === "") {
            this.setState({ ...this.state, tipoPesq: e.target.value, enableInputPesquisa: true, valorPesq: "" });
        } else {
            this.setState({ ...this.state, tipoPesq: e.target.value, enableInputPesquisa: false });
        }

    }

    setValorPesquisa = e => {
        this.setState({ ...this.state, valorPesq: e.target.value });
    }

    handlePageClick = async (data) => {
        let selected = data.selected;
        let offset = Math.ceil(selected * this.state.itensPorPag);

        this.setState({ offset: offset }, () => {
            //this.loadCommentsFromServer();
            this.props.getList(this.state.tipoPesq, this.state.valorPesq,this.props.usuario.unidade, offset, this.state.itensPorPag)
        });
    };

    render() {
        return (
            <div>
                <div>
                    <div className="col-md-6">
                        <label>Pesquisa</label>
                        <div id="custom-search-input">
                            <div className="input-group col-md-12">
                                <span className="input-group-btn">
                                    <select className="btn btn-info btn-sm" id="tipo" name="tipo" onChange={this.setValorTipoPesquisa}>
                                        <option value="">Todos</option>
                                        <option value="id" >Id</option>
                                        <option value="id_cliente" >Id Cliente</option>
                                        <option value="nome_cliente" >Nome</option>
                                        <option value="cpf_cnpj_cliente" >CPF</option>
                                        <option value="carne_id" >Id Carnê</option>
                                    </select>

                                </span>
                                <div className="input-group col-md-12">
                                    <input type="text" className="form-control input-sm" placeholder="Buscar" value={this.state.valorPesq} onChange={this.setValorPesquisa} readOnly={this.state.enableInputPesquisa} />
                                    <span className="input-group-btn">
                                        <button className="btn btn-info btn-sm" type="button" onClick={() => this.props.getList(this.state.tipoPesq, this.state.valorPesq, this.props.usuario.unidade)}>
                                            <i className="glyphicon glyphicon-search"></i>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <table className="table">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Tipo</th>
                                <th>Cliente</th>
                                <th>Banco</th>
                                <th>CPF</th>
                                <th>Vencimento</th>
                                <th>Status</th>
                                <th>Registrado</th>
                                {/* <th>Impresso</th>*/}
                                <th className='table-actions'>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderRows()}

                        </tbody>
                        <tfoot>

                        </tfoot>
                    </table>

                </div>
                <hr />
                <div>

                    <ReactPaginate
                        previousLabel="Anterior"
                        nextLabel="Próximo"
                        breakLabel="..."
                        breakClassName="break-me"
                        pageCount= {this.props.list === undefined ? 0 : Math.ceil(this.props.list.count / this.state.itensPorPag)}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={this.handlePageClick}
                        containerClassName="pagination"
                        activeClassName="active"
                    />

                    <div className="div_right">
                        <label class="select-inline" for="qtdPorPag" >Qtd.Registro por Pág.
                            &nbsp;
                            <select id="qtdPorPag" onChange={this.setItensPorPag} className="mdb-select md-form colorful-select dropdown-primary">
                                <option value="16">16</option>
                                <option value="32" >32</option>
                                <option value="64">64</option>
                                <option value="128">128</option>
                                <option value="192">192</option>
                            </select>
                        </label>

                    </div>
                </div>

            </div>
        )
    }
}

const mapStateToProps = state => ({ list: state.boleto.list, usuario: state.auth.user })
const mapDispatchToProps = dispath => bindActionCreators({ getList, showUpdate, showDelete, sendBoleto, imprimir, showView }, dispath)
export default connect(mapStateToProps, mapDispatchToProps)(BoletoList)


// WEBPACK FOOTER //
// ./src/boleto/boletoList.jsx